import { CSSProperties } from 'react';

export const CollapseItemStyles: CSSProperties = {
	marginBottom: 20,
	backgroundColor: '#f5f5f5',
	border: 'none',
	borderRadius: 'var(--radius)',
};
